module.exports = __webpack_public_path__ + "img/game_detail_penta5_regular.f371deaf.jpg";